global = typeof global !== 'undefined' ? global : window;
global.MESSAGES = (typeof MESSAGES !== 'undefined') ? MESSAGES : {};

global.MESSAGES.ru_ru = {
    locale: {
        uah: 'грн'
    },

    calculator: {
        select_payment_method:         'Укажите способ оплаты. Будете оплачивать товар до отправки или при получении?',
        select_payment_method_caption: 'Вы не указали способ оплаты',
        empty_basket:                  'Для того, чтоб мы могли расчитать стоимость доставки товара - добавьте необходимый товар в корзину',
        empty_basket_caption:          'Ваша корзина пуста',
        unsupported_region:            'К сожалению, мы не можем посчитать доставку в данный регион',
        address_delivery_error:        'Адресная доставка возможна только при предоплате'
    },

    cart: {
        empty:                        'Для того, чтоб оформить заказ надо, сначала, добавить в корзину необходимые товары',
        empty_caption:                'Ваша корзина пуста',
        sure_to_clear_all:            'Точно удалить ВЕСЬ товар из корзины?',
        sure_to_clear_all_caption:    'Удаление товара',
        sure_to_clear_all_yes:        'Удалить',
        alert_delete_ok_btn:          'Удалить',
        alert_delete_cancel_btn:      'Отменить',
        alert_delete_message:         'Точно удалить этот товар из корзины?',
        alert_delete_message_caption: 'Удаление товара',
        alert_delete_message_yes:     'Удалить',
        how_much:                     'Сколько Вам нужно?',
        how_much_full:                'Сколько {name} Вам нужно?',
        cannot_add_less_1:            'Добавить можно не менее 1 штуки',
        cann_add_only_numeric:        'Значение должно быть корректным целым числом',
        cann_add_less_1_full:         'Добавить можно не менее 1 {name}',
        no_items:                     'У Вас нет товаров',
        save_quantity_error:          'Произошла ошибка при сохранении количества',
        error:                        'Ошибка',
        guarantee_item:               'Эта запчасть для гарантийной заявки №',
        guarantee_alert:              'Укажите номера заявок в системе Regulus, для всех гарантийных запчастей',

        when_ordering:         'Вы приступили к оформлению заказа и не можете редактировать товары в корзине.<br>Если Вы хотите отменить оформление и перейти к редактированию жмите <a href="/korzina.html" title="Вернуться к редактированию корзины" style="color: #316bca; font-weight: bold;">сюда</a>',
        when_ordering_caption: 'Идет оформление заказа',
        its_cart:              'Вы уже просматриваете Вашу корзину.<br>Если Вы хотите приступить к оформлению заказа - жмите кнопку «Все верно, приступить к оформлению», которая находится внизу списка выбранных товаров.<br>Если же Вы хотите уйти отсюда - кликайте на любую ссылку или <a href="/" title="Перейти на главную" style="color: #316bca; font-weight: bold;">сюда</a>',
        its_cart_caption:      'Это и есть корзина',

        you_have:                  'У Вас ',
        for_sum:                   'На сумму ',
        confirm_transfer_to_order: 'Вы точно хотите перенести товары в заказ?',
    },

    cartLayout: {
        my_basket: 'Моя корзина',
        total_count: 'У Вас {count}',
        no_items: 'нет товаров',
        total_sum: 'На сумму {sum} {currency}',
        no_items_full: 'У Вас нет товаров',
        your_basket: 'Ваша корзина:',
        clear_basket: 'Очистить корзину',
        you_have: 'Ваш заказ:',
        your_sum: 'На сумму:',
        buy_only_available: 'Купить товары только в наличии',
        make_preorder: 'Оформить предварительный заказ',
        preorder_disclaimer: 'В Вашей корзине есть товары, которые могут отсутствовать на складе. После оформления предварительного заказа с Вами свяжется менеджер для согласования деталей.',
        make_order: 'Оформить заказ',
        continue_shopping: 'Продолжить покупки',
        empty: 'У Вас нет в корзине товаров. Добавьте необходимые товары в корзину, после чего перейдите к оформлению заказа нажав кнопку «Оформить заказ», которая находится чуть ниже справа.',
        productsPlural: '{n, plural, one{товар} few{товара} many{товаров} other{товаров}}',
        discount: 'СКИДКА',
    },

    cartPage: {
        empty_cart: 'Ваша корзина пуста! Вернитесь к каталогу товаров, добавьте необходимый товар в Вашу корзину и тогда, Вы сможете оформить заказ.',
        products_desktop: 'Ваш заказ: <span class="basket_total3">{count, plural, one{# товар} few{# товара} many{# товаров} other{# товаров}}</span>',
        summa_desktop: 'На сумму: <span class="basket_total4">{summa} {currency}</span>',
        you_have: 'У Вас есть {count, plural, one{# заказ который} few{# заказа которых} many{# заказов которые} other{# заказов которые}} мы еще не проверили. Вы можете добавить товар из корзины в {count, plural, many{один из этих заказов} other{этот заказ}} или оформить новый заказ:',

        transfer: {
            add: 'Добавить товар в заказ №{order}',
            success: 'Ваша корзина пуста. Все товары из нее были перенесены в заказ №{order}.'
        },

        make_order_new: 'Оформить новый заказ',
        go_make_order: 'Все верно, приступить к оформлению',
        total_sum: 'Общая сумма: {total}',
    },

    basketItem : {
        delete: 'Удалить из корзины',
        see_full: 'Кликните, чтоб перейти к подробному описанию товара',
        quantity: 'к-во:',
        price: 'Цена:',
        articul: 'Артикул:',
        code: 'Код товара:',
        name: 'Название:',
        availability: 'Наличие:',
        renovated_cross: 'Отреставрированная крестовина №{spider_index} от {spider_time}'
    },

    basketUpdatePrices : {
        button:  'Сначала обновите цены',
        tip: 'Цена на товар изменилась с учетом курсов валют.<br>Пожалуйста, обновите цену.'
    },

    contacts: {
        alert:         'Внимание! Очень часто нам на почту приходят вопросы следующего характера:<br>«Мне надо ТЭН на Indesit...», или «А этот мотор подойдет на пылесос...?», или «Какой насос мне надо для...»<br>Это все можно отнести к варианту запроса запчастей. А для этого у нас есть специальная форма «<a href="/zapros_zapchastey/" target="_BLANK">Запрос запчастей</a>» в верхнем меню нашего сайта.<br>Если Вы хотите получить ответ на подобные вопросы, Вам необходимо заполнить эту форму. Дело в том, что, чтоб дать Вам точный ответ, нам надо точная информация, и в каждом случае она разная.<br><br>На все вопросы, которые придут нам на почту и которые касаются подбора запчастей к технике - Вы получите стандартный ответ с ссылкой на эту же форму.<br>Поэтому, чтоб сэкономить свое время - сразу заполняйте ее.<br><br>По всем остальным вопросам - милости просим! Заранее благодарим за понимание!',
        alert_caption: 'Что не стоит писать',

        form_name_short:            'Имя не может быть короче 2х символов',
        form_name_short_caption:    'Укажите Имя',
        form_subject_short:         'Тема письма не может быть короче 5ти символов',
        form_subject_short_caption: 'Укажите тему',
        form_text_short:            'Текст письма не может быть короче 20ти символов',
        form_text_short_caption:    'Введите текст письма',
        form_error:                 'Произошла ошибка',
    },

    credits: {
        money:                  '{money} грн',
        collapse:               'Свернуть',
        expand:                 'Пополнить',
        wrong_sum:              'Вы неверно указали сумму пополненения. Сумма не может быть меньше 1грн.',
        wrong_sum_caption:      'Неверная сумма',
        sms_sent:               'СМС с реквизитами отправлено на указанный Вами номер.',
        sms_sent_caption:       'СМС отправлено.',
        sms_error:              'При отправке СМС произошла ошибка',
        email_sent:             'Письмо с реквизитами отправлено на указанный Вами адрес.',
        email_sent_caption:     'Письмо отправлено.',
        email_error:            'При отправке письма произошла ошибка',
        payment_error:          'Ошибка при создании платежки',
        payment_2_error:        'Ошибка 2 при создании платежки',
        wrong_payment_method:   'Ошибка определения способа оплаты',
        continue:               'Продолжить',
        dont_continue:          'Не продолжать',
        w1_alert:               'При оплате через систему «Единая касса» Вам необходимо оплатить «Внутреннюю комисию» в размере 5% от суммы платежа.<br>Поэтому, к оплате в этой системе будет предложена сумма на 5% выше, той которую Вы указали.<br><br>К примеру: Вам необходимо оплатить нам 100грн. При совершении платежа по системе «Единая касса» наш сайт автоматически увеличит платеж до 105грн. (на 5%). <br> После того, как платеж будет выполнен - на Ваш баланс, в нашем магазине, будет зачисленно 100грн., а 5грн. пойдет на оплату, той самой «внутренней комиссии».<br> Подробнее <a href="/faq/pochemu-k-platezham-edinyj-koshelek-pribavljaetsja-5.html" target="_BLANK" style="color: #4182b4;">ТУТ</a>.',
        w1_alert_caption:       'Внимание!',
        w1_alert_continue:      'Продолжить',
        w1_alert_dont_continue: 'Не продолжать',
        limit_error:            'Ошибка при работе с кредитным лимитом, обратитесь к нам в офис.',
        saved_card_paid:        'Оплата успешно зачислена на Ваш баланс',
        saved_card_paid_title:  'Успешно оплачено',
        saved_card_delete:      'Удалить карту?'
    },

    finder: {
        form_model_short:         'Название модели должно состоять не менее чем из 4-х символов',
        form_model_short_caption: 'Неверный формат модели',
        error:                    'Ошибка',
        to_main_page:             'На главную'
    },

    main: {
        skype_alert:        '1. При звонке через Skype время вызова (дозвона) может составить от нескольких секунд до одной минуты. <br><br>2. Связь через скайп может быть только в виде звонков к нам. Чат или звонки от нас к Вам недоступны.<br><br>Подробнее о звонках Skype <a href="/faq/chto-takoe-on-line-zvonok.html" title="Кликните, чтоб перейти к статье">читайте тут.</a>',
        search_input_short: 'Поисковый запрос должен содержать минимум 3 символа',
    },

    cabinet: {
        balance: {
            no_orders_ukraine: 'Внимание! У Вас нет заказов которые ожидают оплаты. В связи с этим, мы не рекомендуем Вам пополнять баланс до того момента, пока наш сотрудник не проверит Ваш заказ и не свяжется с Вами.<br>Если Вы только оформили заказ - он получает статус «Новый» и переводится на оплату, только после проверки нашим менеджером (в рабочее время). Как правило, после проверки мы связываемся с Вами и сообщаем о необходимости совершения оплаты.',
            no_orders_foreign: 'Внимание! Вы не можете пополнить баланс, так как у Вас нет заказов которые ожидают оплаты. В связи с этим, мы не рекомендуем Вам пополнять баланс до того момента, пока наш сотрудник не проверит Ваш заказ и не свяжется с Вами.<br>Если Вы только оформили заказ - он получает статус «Новый» и переводится на оплату, только после проверки нашим менеджером (в рабочее время). Как правило, после проверки мы связываемся с Вами и сообщаем о необходимости совершения оплаты.',
            bigger_sum_ukraine: 'Внимание! Вы указали сумму, которая превышает необходимую сумму пополнения, на данный момент. Если Вы решите вернуть себе часть не потраченных средств - Вам придется оплатить все комиссии которые возникают при зачислении и возврате остатка.<br>Если у Вас возникли вопросы звоните на 098 000-86-86',
            bigger_sum_foreign: 'Внимание! Вы не можете пополнить баланс, так как указали сумму, которая не соответствует необходимой сумме пополнения, на данный момент.<br>Если у Вас возникли вопросы свяжитесь с нами, удобным для Вас способом, и мы на них ответим.'
        },

        orders: {
            cancel_error:                   'Ошибка при отмене заказа',
            order_cancelled:                'Ваш заказ №{id} отменен',
            order_cancelled_caption:        'Заказ отменен',
            error:                          'Ошибка',
            cancel:                         'Отменить',
            dont_cancel:                    'Не отменять',
            cancel_order_alert:             'Это единственный товар в этом заказе, поэтому его нельзя удалить из заказа, но можно отменить весь заказ. Отменить его?',
            cancel_order_alert_caption:     'Отменить заказ?',
            cancel_order_alert_cancel:      'Отменить',
            delete:                         'Удалить',
            dont_delete:                    'Не удалять',
            delete_confirm:                 'Точно удалить этот товар из Вашего заказа?',
            delete_confirm_caption:         'Удаление товара',
            delete_confirm_delete:          'Удалить',
            delete_error:                   'Ошибка при удалении товара',
            quantity_less_0:                'Количество товара в заказе не может быть меньше одного. Если Вы хотите убрать эту позицию из заказа - нажмите на крестик в левом, верхнем углу блока с этим товаром.',
            quantity_less_0_caption:        'Не верное количество',
            quantity_change_error:          'Ошибка при сохранениии количества товара',
            cannot_change_quantity:         'Вы не можете менять количество на этот товар в этом заказе, так как уже за установленное количество снят задаток с Вашего баланса. По всем возникшим вопросам - обращайтесь к нашим менеджерам  по телефонам указанным в контактах.',
            cannot_change_quantity_caption: 'Нельзя изменить количество',
            add:                            'Добавить',
            dont_add:                       'Не добавлять',
            sure_add_from_cart:             'Точно добавить все товары из Вашей корзины в этот заказ?',
            sure_add_from_cart_caption:     'Добавить товары?',
            sure_add_from_cart_add:         'Добавить',
            empty_cart:                     'Ваша корзина пустая, мы не можем из нее что-то добавить в заказ',
            order_confirm_error:            'Ошибка при подтверждении заказа',
            cancel_order:                   'Точно отменить этот заказ?',
            cancel_order_caption:           'Отменить заказ?',
            cancel_order_yes:               'Да',
            cancel_order_cancel:            'Нет',
            cannot_change_quantity_reserved: 'Вы не можете менять количество на этот товар в этом заказе, так как текущее количество товара уже зарезервировано. По всем возникшим вопросам - обращайтесь к нашим менеджерам  по телефонам указанным в контактах.',
            cannot_change_quantity_reserved_caption: 'Нельзя изменить количество',
        },

        profile: {
            phone_short:          'Номер телефона слишком короткий',
            phone_taken:          'Этот номер телефона уже закреплен за другим клиентом.<br>Если это Ваш номер, и Вы не закрепляли этот номер за другими аккаунтами - обратитесь к нашим сотрудникам.',
            phone_taken_caption:  'Этот номер уже существует в нашей базе',
            phone_error:          'Произошла ошибка',
            phone_delete_confirm: 'Точно удалить этот номер из контактов?',
            error:                'Ошибка',
            name_short:           'Введите Ваши фамилию и имя',
        },

        requests: {
            comment_text_short: 'Текст комментария слишком короткий',
            error:              'Ошибка',
        }
    },

    request: {
        enter_full_model:           'Введите полную модель',
        enter_prod_number:          'Введите S/N или Prod номер техники',
        prod_number_wrong:          'Не верно указан номер',
        code_length_error:          'Код должен содержать от 5-ти до 6-ти цифр. <br> И больше никаких символов',
        save_error:                 'При сохранении запроса произошла ошибка',
        save_error_caption:         'Ошибка при сохранении',
        error:                      'Произошла ошибка',
        enter_tech:                 'Выберите вид техники',
        enter_tech_caption:         'Не указан вид техники',
        enter_brand:                'Выберите торговую марку',
        enter_brand_caption:        'Не указана торговая марка',
        model_short:                'Модель не может быть короче 5-ти символов',
        model_short_caption:        'Не верно введена модель',
        description_short:          'Подробное описание запчасти слишком короткое, оно не может быть короче 10-ти символов',
        description_short_caption:  'Не верно указано описание детали',
        image_delete_error:         'При удалении произошла ошибка',
        image_delete_error_caption: 'Фото не удалено',

        upload: {
            error_caption: 'Файл не загружен',
            allowed_types: 'Для загрузки разрешены следующие расширение файла: jpg, jpeg, png',
            error: 'При загрузке файла возникла ошибка',
            size_error: 'Загружаемый файл не должен превышать 20Mb',
            count_error: 'Вы загрузили максимальное количество фото',
        }
    },

    reviews: {
        already_voted:             'Вы уже оценили этот отзыв',
        your_own_comment:          'Вы не можете оценивать свой отзыв',
        error:                     'Ошибка',
        login_to_vote:             'Для того чтоб оценить отзыв - Вам необходимо авторизоваться',
        form_text_short:           'Отзыв не может быть таким коротким',
        form_text_short_caption:   'Короткий текст отзыва',
        form_name_short:           'Ваше имя может состоять не менее чем из 3-х букв',
        form_name_short_caption:   'Короткое Ваше имя',
        form_name_not_unique:      'Имя которое Вы указали, уже используется другим клиентом на нашем сайте.<br>По правилам нашего сайта имена которыми подписываются клиенты - должны быть уникальными.',
        code_length_error:         'Код должен содержать от 5-ти до 6-ти цифр. <br> И больше никаких символов',
        save_error:                'При сохранении отзыва произошла ошибка',
        save_error_caption:        'Ошибка при сохранении',
        error_happened:            'Произошла ошибка',
        form_answer_short:         'Ответ не может быть таким коротким',
        form_answer_short_caption: 'Короткий текст отзыва',

        modal_text_for_google:     'Спасибо за Ваш отзыв, будем Вам очень благодарны, если Вы еще, оставите отзыв в Google. <br/>' +
                                   '<a href="https://www.google.com/search?q=%D0%BC%D0%B0%D1%81%D1%82%D0%B5%D1%80+%D0%BF%D0%BB%D1%8E%D1%81&ie=utf-8&oe=utf-8&client=firefox-b-ab#lrd=0x472d5b40451a2fbd:0x6ef3646230615b12,1," id="googleTestimonialBtnInAlert" target="_blank">' +
                                      '<span id="SPAN_2">' +
                                         '<span id="SPAN_3"></span>' +
                                         '<span id="SPAN_4">Написать отзыв Google</span>' +
                                       '</span>' +
                                   '</a>' ,
        modal_title_for_google:    'Спасибо за отзыв',
        modal_btn_for_google:      'Хорошо'

    },

	ideas: {
		already_voted:             'Вы уже оценили это предложение',
		your_own_comment:          'Вы не можете оценивать свое предложение',
		error:                     'Ошибка',
		login_to_vote:             'Для того чтоб оценить предложение - Вам необходимо авторизоваться',
		form_text_short:           'Предложение не может быть таким коротким',
		form_text_short_caption:   'Короткий текст предложения',
		form_name_short:           'Ваши имя может состоять не менее чем из 3-х букв',
		form_name_short_caption:   'Короткое Ваше имя',
		form_name_not_unique:      'Имя которое Вы указали, уже используется другим клиентом на нашем сайте.<br>По правилам нашего сайта имена которыми подписываются клиенты - должны быть уникальными.',
		code_length_error:         'Код должен содержать от 5-ти до 6-ти цифр. <br> И больше никаких символов',
		save_error:                'При сохранении произошла ошибка',
		save_error_caption:        'Ошибка при сохранении',
		error_happened:            'Произошла ошибка',
		form_answer_short:         'Ответ не может быть таким коротким',
		form_answer_short_caption: 'Короткий текст отзыва',
	},

    good: {
        show_all_codes: 'Показать все коды',
        hide_all_codes: 'Скрыть коды',
        show_more_thumbs: 'еще фото',
        hide_more_thumbs: 'меньше фото',
        track_arrival_alert: 'Если товар появится на складе в течении месяца — Вам прийдет СМС.<br>Если нет — обновите статус ожидания через месяц нажав на эту кнопку',
        track_arrival_alert_caption: 'Ожидаем товар',
        one_click_order_created: 'Вы успешно оформили заказ в 1 клик.',
        one_click_existing_order_used: 'Ваш товар будет добавлен к заказу {order}.',
        one_click_order_phone: 'Телефон должен состоять из {length} цифр. Укажите пожалуйста украинский номер телефона в формате " +380.."',
        one_click_order_created_caption: 'Заказ успешно оформлен',
        one_click_order_manager_call: 'Ожидайте звонка менеджера',

        one_click_no_quantity: 'Поле количество не может быть пустым',
        one_click_is_not_int: 'Поле количество должно быть числом',

        one_click: {
            enter_phone_number: 'Укажите ваш номер телефона:',
            buy: 'Купить в один клик',
            quantity: 'Количество:',
            order: 'Заказать',
            close: 'Закрыть форму',
            i_agree: 'Я согласен с <a href="/faq/pravila-i-uslovija-registracii.html" target="_blank" style="color:#fff">условиями работы</a>',
            accept_agreement: 'Вы должны принять условия работы'
        },

        reviews: {
            name_short:            'Укажите имя которое будет состоять не менее чем из 3-х символов',
            name_short_caption:    'Слишком короткое имя',
            comment_short:         'Комментарий должен содержать не менее чем 20 символов',
            comment_short_caption: 'Ваш комментарий - слишком короткий',
            error_happened:        'Произошла ошибка',
            comment_added:         'Благодарим за Ваш комментарий. Он будет добавлен к товару после проверки администратором.',
            comment_added_caption: 'Комментарий добавлен',
        },

        models: {
            not_found: 'Нет подходящих моделей'
        },

        favorite: {
            where_to_find: 'Товары, добавленные в избранные, Вы сможете найти во вкладке «Избранное» в верхнем меню.',
            signup: 'Чтобы воспользоваться функцией избранных товаров, Вам необходимо авторизоваться',
            confirm_remove: 'Вы уверены?'
        },

        check_availability: {
            first_time: 'Вы можете проверить наличие 10 раз в сутки',
            limit_reached: 'Вы исчерпали лимит проверки наличия товаров на сегодня. Проверить наличие можно 10 раз в сутки. Функция проверки будет доступна завтра'
        }
    },

    catalog: {
        caption: 'Каталог товаров',
        click_to_see_count: 'Нажмите на кнопку, чтобы проверить количество на складе',
        '3dphoto_hint_short': 'Этот товар можно покрутить в 3D',
        have_ucenka_products: 'Есть уцененный товар',
        price_small: 'цена:',
        price_roznicnaya: 'Розничная цена товара:',
        interest: 'Интерес',
        add_to_favorite: 'Добавить в избранное',
        field_articul: 'Артикул:',
        add_to_cart: 'Добавить в корзину',
        one_click_buy: 'Купить в 1 клик',
        goto_product: 'Подробнее',
        not_available: 'нет в наличии',
        is_available: 'в наличии',
        warehouse: 'На складе',
        shop: 'В магазине'
    },

    common: {
        enter_email:          'Введите Вашу електронную почту в соответсвующем поле',
        empty_email_caption:  'Не введен e-mail',
        email_format_message: 'E-mail может содержать только английские буквы, цыфры, точки, а также символ «@»',
        email_format_caption: 'Не верный формат электронной почты',
        enter_phone:          'Необходимо указать номер мобильного телефона',
        enter_phone_caption:  'Неверный формат номера',
        phone_length:         'Номер телефона должен содержать {length, plural, one{# цифру} few{# цифры} many{# цифр} other{# цифр}}',
        ok_btn:               'OK',
        cancel_btn:           'Отмена',
        name_format:          'Имя должно состоять более чем из 2х символов',
        name_format_caption:  'Неверный формат имени',

        enter_city:     'Укажите населенный пункт',
        enter_country:  'Укажите страну',
        error_happened: 'Извините, произошла ошибка',

        work_time:          'Рабочее время',
        work_time_continue: '.<br>Продолжить?',
        work_time_caption:  'Подтвердите действие',
        work_time_yes:      'Да',
        work_time_no:       'Нет, спасибо',

        fixing_leave_on:  'Оставить включенным',
        fixing_leave_off: 'Оставить отключенным',
        fixing_turn_off:  'Отключить',
        fixing_turn_on:   'Включить',

        alert_default_caption:   'Внимание!',
        alert_default_yes:       'Да',
        alert_default_no:        'Нет',
        confirm_default_caption: 'Сделайте выбор',
        confirm_default_yes:     'Да',
        confirm_default_no:      'Нет',
        cancel: 'Отмена',

        open_call_text:    'Данная кнопка позволяет позвонить к нам прям с сайта, без использования дополнительных программ, или телефонов.<br>Звонить можно с любой точки мира абсолютно бесплатно.<br><br>Для того, чтоб звонок был успешным - у Вас должен быть микрофон.<br>Помимо этого при подключении у Вас появится окно с настройками, где Вам будет предложено разрешить доступ к Вашему микрофону. Вам необходимо подтвердить разрешение, в противном случае мы не будем Вас слышать.<br><br><font color="red">Во время звонка не переходите на другие страницы иначе звонок оборвется</font>.<br>Более подробно <a href="' + 'faq/chto-takoe-on-line-zvonok.html" title="Кликните, чтоб перейти к статье">читайте тут.</a>',
        open_call_caption: 'Пожалуйста, прочтите.',

        skype_call_text:    '1. При звонке через Skype время вызова (дозвона) может составить от нескольких секунд до одной минуты. <br><br>2. Связь через скайп может быть только в виде звонков к нам. Чат или звонки от нас к Вам недоступны.<br><br>Подробнее о звонках Skype <a href="' + 'faq/chto-takoe-on-line-zvonok.html" title="Кликните, чтоб перейти к статье">читайте тут.</a>',
        skype_call_caption: 'Внимание',

        restore_password_title: 'Восстановить пароль',
        save_password: 'Сохранить пароль',
        to_your_phone: 'На ваш моб. телефон',
        confirm_code_sent: 'отправлен код подтверждения для восстановления пароля',
        enter_new_password: 'Введите новый пароль',
        enter_confirm_code: 'Введите код из СМС',
        nothing_found: 'Ничего не найдено',

        back_to_home: '&larr; Перейти на главную',
        price_upper: 'ЦЕНА',
    },

    user: {
        logout_confirm:            'Вы точно хотите выйти из Вашей учетной записи?',
        logout_caption:            'Выход',
        logout_yes:                'Да',
        logout_no:                 'Нет',
        confirm_code_send_error:   'Произошла ошибка при отправке кода',
        confirm_code_wrong:        'Код подтверждения введен не верно, у Вас осталась 1 попытка.<br>Если код отправлялся Вам несколько раз, то вводить надо именно последний.',
        confirm_code_second_wrong: 'Код подтверждения дважды введен не верно. Выдержите паузу, оновите страницу и повторите попытку. Если SMS долго не приходит - попробуйте повторить позже',
        confirm_code_verify_wrong: 'Произошла ошибка при проверке кода',
        password_short:            'Пароль слишком короткий',
        password_short_length:     'Пароль должен быть не менее 5-ти символов',
        password_format:           'Пароль должен состоять только из цифр и английских букв',
        password_forgot:           'Забыли пароль',
        recovery_code_sent:        'На ваш моб телефон отправлен код подтверждения для восстановления пароля',

        password_format_caption:   'Неверный формат пароля',
        phone_length:              'Телефон должен состоять из {length} цифр',
        phone_length_caption:      'Неверный формат телефона',
        phone_required:            'Регистрация возможна только на номер мобильного',
        reg_agree:                 'Для регистрации, Вы должны подтвердить согласие с условиями регистрации',
        enter_confirm_code:        'Введите код подтверждения из SMS',
        confirm_code_wrong_short:  'Неверно введен код',
        error_happened:            'Произошла ошибка',
    },

    operator: {
        something_wrong:   'Что-то пошло не так',
        enter_credentials: 'Введите номер и пароль',
        sure_logout:       'Точно выйти?',
    },

    order: {
        error_happened:                    'Произошла ошибка',
        no_accept_rules:                   'Вы должны согласиться с правилами',
        phone_taken:                       'В нашей базе уже существует клиент с таким номером телефона.<br>Если это Ваш номер - нажмите «<font color=blue>Я постоянный клиент</font>» и авторизируйтесь.',
        phone_taken_caption:               'Вы уже зарегистрированы',
        phone_taken_short:                 'В нашей базе уже существует другой клиент с таким номером телефона.',
        phone_taken_short_caption:         'Чужой номер',
        phone_exists:                      'Ваш телефон уже есть в нашей системе, пожалуйста авторизуйтесь',
        format_words:                      '{field} может содержать только украинские и русские буквы, и не может содержать других символов или пробелов',
        format_words_en:                   'По решению Укрпочты - все данные для международных отправок должны быть заполнены на английском языке',
        format_words_caption:              'Правильно введите {field}',
        format_length:                     '{field} не может быть короче 2-х символов',
        format_length_caption:             'Укажите Ваше {field}',
        no_city:                           'Мы не нашли такого населенного пункта в нашей базе.<br>Пожалуйста, выберите населенный пункт из выпадающего списка.<br>Если же там нет того, который Вам надо - обратитесь к нам по телефону в рабочее время.',
        no_city_caption:                   'Выберите город или поселок из списка',
        auth_error:                        'Ошибка авторизации',
        pass_format:                       'Пароль должен состоять только из цифр и английских букв',
        pass_format_caption:               'Неверный формат пароля',
        pass_length:                       'Пароль слишком короткий',
        pass_length_caption:               'Неверный формат пароля',
        phone_length:                      'Телефон должен состоять из {length} цифр',
        phone_length_caption:              'Неверный формат номера',
        set_middlename_caption:            'Ваше отчество',
        set_middlename:                    'Укажите Ваше отчество',
        select_delivery:                   'Укажите службу доставки и остальную информацию',
        select_delivery_caption:           'Вы не указали службу доставки',
	    select_delivery_method:            'Укажите способ доставки',
	    select_delivery_method_caption:    'Вы не указали способ доставки',
        select_np_departament:             'Укажите отделение Новой Почты на которое необходимо доставить посылку',
        select_np_departament_caption:     'Вы не указали отделение',
        select_meest_departament:          'Укажите отделение Meest Почты на которое необходимо доставить посылку',
        select_meest_departament_caption:  'Вы не указали отделение',
        select_payment_method:             'Укажите способ оплаты за товар',
        select_payment_method_caption:     'Вы не указали способ оплаты',
        select_obreshtovka:                'Укажите делать обрешетку, или нет?',
        select_obreshtovka_caption:        'Обрешетка надо?',
        order_error:                       'При оформлении заказа произошла ошибка, если это будет повторяться обратитесь к нам по телефону',
        street_length:                     'Название улицы должно содержать не менее 4-х символов.',
        street_length_caption:             'Укажите улицу',
        street_format:                     'В названии улицы можно использовать только украинские и русские буквы, цифры, а также точку и дефис. Другие символы запрещены.',
        street_format_caption:             'Не верный формат улицы',
        enter_street:                      'Введите название улицы, куда надо доставить посылку',
        enter_street_en:                   'По решению Укрпочты - все данные для международных отправок должны быть заполнены на английском языке',
        enter_region:                      'Введите название области, региона..., куда надо доставить посылку. Для ввода разрешены только английские и русские буквы, а так же пробел и дефис.',
        enter_region_en:                   'По решению Укрпочты - все данные для международных отправок должны быть заполнены на английском языке',
        enter_region_caption:              'Не верный формат области',
        enter_city:                        'Введите название города, куда надо доставить посылку. Для ввода разрешены только английские и русские буквы, а так же пробел и дефис.',
        enter_city_en:                     'По решению Укрпочты - все данные для международных отправок должны быть заполнены на английском языке',
        enter_city_caption:                'Не верный формат города',
        index_format:                      'Почтовый индекс должен состоять из 5 цифр.',
        index_format_caption:              'Укажите почтовый индекс',
        house_format:                      'Номер дома может содержать только цифры, украинские и русские буквы, а также дефис и косая черта. Другие символы запрещены.',
        house_format_en:                   'По решению Укрпочты - все данные для международных отправок должны быть заполнены на английском языке',
        house_format_caption:              'Не верный формат номера дома',
        error_1:                           'Ошибка 1',
        obrestovka_abroad_denied:          'Мы не можем оформить этот заказ в другую страну, так как в нем есть хрупкий товар, который мы не отправляем за пределы Украины.',
        obrestovka_abroad_denied_caption:  'Удалите хрупкий товар из заказа',
        dont_call_if_all_good:             'Мне можно не звонить, если все есть и цены актуальны.',
        dont_call_send:                    'Мне можно не звонить, если все есть и цены актуальны, а сразу отправлять (номер декларации Вам придет в СМС после 18:00).',
        dont_call_pay:                     'Мне можно не звонить, если все есть и цены актуальны, а сразу переводить на оплату.',
        please_agree_rules:                'Вы не подтвердили согласия с условиями работы нашего магазина.<br>Прочитайте «условия работы» и поставьте галочку, что Вы согласны с ними.<br>Только после этого, Вы сможете продолжить оформление заказа.',
        please_agree_rules_caption:        'Подтвердите согласие с правилами',
    },

    seo: {
        title_length:      'Заглавие не может быть короче 10-ти символов',
        text_length:       'SEO текст не может быть короче 100-ти символов',
        text_exists:       'В этом разделе уже существует текст для всего раздела',
        generation_exists: 'В этом разделе уже существует текст генерации',
        error_happened:    'Произошла ошибка',
        enter_pass:        'Введите пароль',
        delete_all_1:      'Удалить ВСЕ сгенерированные тексты для этого раздела?',
        delete_all_2:      'Точно удалить ВСЕ сгенерированные тексты для этого раздела?',
        delete_all_3:      'Точно-точно удалить ВСЕ сгенерированные тексты для этого раздела?',
        delete_all_4:      'Ты готов потом получить пиздюлей, если этого не надо было делать?',
        deleted:           'Удалено!',
        available_title_length: 'Длина Title должна быть от 45 до 255 символов',
        available_description_length: 'Длина Description должна быть от 130 до 300 символов',
        available_h1_length: 'Значение H1 может отсутствовать или должно быть длиной от 20 до 75 символов',
    },

    filters: {
        enter_pass:     'Введите пароль',
        remove_desc:    'Удалить это описание?',
        error_happened: 'Произошла ошибка',
        no_content:     'Нет подходящих товаров'
    },


    email: {
        already_sent_title: 'Уже отправлено',
        already_sent: 'Письмо с подтверждением уже отправлено. Если не пришло, попробуйте немного позже.',
        just_sent_title: 'Отправили письмо',
        just_sent: 'Отправили письмо с подтверждением, проверьте свой почтовый ящик'
    },

    module: {
        added_to_cart:          'Модуль добавлен в корзину',
        added:                  'Добавлено',
        you_can_accept_rules:   'Вы должны согласиться с правилами',
        specify_brand:          'Укажите бренд',
        specify_technic:        'Укажите технику',
        specify_service:        'Укажите услугу',
        specify_declaration:    'Укажите корректную декларацию',
        specify_comment:        'Укажите комментарий',
        enter_brand: 'Выберите бренд',
    },

    motor: {
        added_to_cart:          'Мотор добавлен в корзину',
        added:                  'Добавлено',
        specify_repair_type:    'Укажите тип ремонта',
        you_can_accept_rules:   'Вы должны согласиться с правилами',
        specify_declaration:    'Укажите корректную декларацию',
    },

    spider: {
        added_to_cart:          'Крестовина была добавлена в корзину',
        added:                  'Добавлено',
        you_can_accept_rules:   'Вы должны согласиться с правилами',
        specify_declaration:    'Укажите корректную декларацию',
    },

    delivery_page: {
        select_city: 'Выберите город',
        enter_country: 'Укажите страну',
        enter_city: 'Укажите город',
        set_payment_type: 'Укажите тип оплаты',
        address_delivery_error: 'Адресная доставка возможна только при предоплате',
        enter_weight: 'Введите вес',
        enter_cost: 'Введите стоимость',
        parameters_error: 'Нет возможности доставить с такими параметрами'
    },

    preorder: {
        with_privat24: 'используя Приват24',
        with_credit_card: 'используя кредитную карту',
        with_terminal: 'через терминал',
        with_requisites: 'по реквизитам',
        using_privat24: 'Используя Приват24',
        using_credit_card: 'Используя кредитную карту',
        using_terminal: 'Используя терминал',
        using_requisites: 'Используя реквизиты',
        credit_desc: `Если Вы регулярно покупаете в нашем магазине, и используете этот
				способ для пополнения баланса – Вы можете привязать Вашу карту к
				этому аккаунту. Это облегчит процесс следующих оплат.<br/><br/>

				Для этого достаточно просто поставить галочку рядом с «запомнить
				карту для оплат» и совершить любую оплату этим способом. После
				того, как мы получим от Вас эту оплату, мы сохраним необходимые
				данные для того, чтоб облегчить Ваши следующие оплаты.<br/><br/>

				И в следующий раз у Вас в меню появится дополнительный способ
				оплаты, с помощью Вашей сохраненной карты.<br/><br/>

				Но не переживайте, никто кроме Вас не сможет провести оплату.
				Все, важные, данные которые нам передает банк, после Вашей
				оплаты – зашифрованы, и расшифровать их может только тот же
				банк. Не зашифрована только общая информация о карте, такая как,
				Фамилия Имя, последние цифры карты, и тип карты.<br/><br/>

				Более того, при каждой оплате банк будет требовать Ваше личное
				подтверждение.<br/><br/>

				Ну и конечно, Вы можете удалить эту карту в любой
				момент.<br/><br/>

				Если у Вас остались вопросы – звоните нам в рабочее время, и мы
				на них ответим.`,
        order_completed_payment: 'Ваш заказ оформлен и ожидает оплаты.',
        order_completed_desc: 'Если у Вас есть вопросы или сомнения касательно оформленного заказа, – лучше свяжитесь с менеджером, чтобы проконсультироваться, если нет, – <b>пожалуйста, оплатите Ваш заказ</b>.',
        balance_info: 'Информация о балансе:',
        current_balance: 'Ваш текущий баланс:',
        balance_negative: 'На вашем балансе отрицательная сумма (Долг перед магазином). Вам нужно оплатить долг перед магазином в размере <b>{balance} грн</b> + сумма текущего заказа <b>{order_sum}&nbsp;грн.</b>',
        pay_order_sum: 'Оплатить сумму заказа.',
        including_debt: 'Включая сумму долга:',
        on_your_balance: 'На вашем балансе',
        balance_enough: 'Этого достаточно для оплаты заказа.',
        use_balance: 'Оплатить <b>заказ средствами с баланса</b>',
        you_need_to_surcharge: 'Для полной оплаты Вам нужно доплатить <b>еще {charge}&nbsp;грн.</b>',
        use_surcharge: 'Доплатить',
        you_can_pay_order_sum: 'Вы можете оплатить всю сумму заказа',
        pay_full: 'Оплатить всю сумму',
        you_can_use_credit_limit: 'Вы можете оплатить заказ в счет кредитного лимита.',
        pay_credit_limit: 'Оплатить заказ в счет кредитного лимита',
        you_can_pay_later: 'Вы можете оплатить заказ позже. Это можно будет сделать через <a href={url}>личный кабинет</a>.',
        and_bank_fee: '+ комиссия банка <b>{fee} грн</b>',
        pay_later: 'Оплатить позже',
        privat24: `<b>Для оплаты Приват 24:</b><br/>
        <b>1.</b> Нажмите кнопку «Оплатить сумму заказа»<br/>
        <b>2.</b> Кликните «Другой способ оплаты»`,
        requisites: {
            recipient: 'Получатель платежа:',
            account: 'Расчетный счет:',
            erpoy: 'Код ОКПО(ЕРПОУ):',
            mfo: 'МФО:',
            bank: 'Учреждение банка:',
            sum: 'Сумма платежа:',
            purpose: 'Назначение платежа:',
            print: 'Распечатать реквизиты',
            send_sms: 'Отправить реквизиты по смс',
            send_mail: 'Отправить реквизиты на почту',
            received_finish: 'Реквизиты получены, завершить оформление',
            minimize: 'Свернуть',
        },
        enter_phone: 'Укажите номер телефона',
        enter_email: 'Укажите email',
        credit_card: 'Кредитная карта для оплаты:',
        credit_card_other: 'Оплатить другой картой',
        save_credit_card_title: 'Сохранение банковских карт',
        save_card: 'Сохранить карту',
        result_sum: 'Итого к оплате:'
    },

    breadcrumbs: {
        go_back: 'Вернуться'
    },

    menu: {
        see_more: 'Смотреть еще',
        favorites: 'Избранные товары'
    },

    bigPhoto: {
        open: 'Оригинальное фото в отдельном окне'
    },

    validation: {
        required: 'Это поле обязательно для заполнения',
        numbers_only: 'Пожалуйста, введите только цифры',
    },
};
